import { getTeamInitialState } from './team'

export * from './team'

export const getInitialState = () => ({
  team: getTeamInitialState(),
})
